import { render, staticRenderFns } from "./XimuPicExchange.vue?vue&type=template&id=6f79e8d2&scoped=true"
import script from "./XimuPicExchange.vue?vue&type=script&lang=js"
export * from "./XimuPicExchange.vue?vue&type=script&lang=js"
import style0 from "./XimuPicExchange.vue?vue&type=style&index=0&id=6f79e8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f79e8d2",
  null
  
)

export default component.exports